export const Getters = {
    LIST: 'list',
    GET_LATEST: 'getLatest',
};

export const Mutations = {
    ADD: 'add',
}
